var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "label",
    {
      staticClass: "toggle-switch",
      class: [_vm.sizeClass, { disabled: _vm.disabled }]
    },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.localValue,
            expression: "localValue"
          }
        ],
        attrs: { id: _vm.toggleId, type: "checkbox", disabled: _vm.disabled },
        domProps: {
          checked: Array.isArray(_vm.localValue)
            ? _vm._i(_vm.localValue, null) > -1
            : _vm.localValue
        },
        on: {
          change: function($event) {
            var $$a = _vm.localValue,
              $$el = $event.target,
              $$c = $$el.checked ? true : false
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v)
              if ($$el.checked) {
                $$i < 0 && (_vm.localValue = $$a.concat([$$v]))
              } else {
                $$i > -1 &&
                  (_vm.localValue = $$a
                    .slice(0, $$i)
                    .concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.localValue = $$c
            }
          }
        }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "toggle-slider round" })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }